<div class="code" [innerHTML]="codeInStyleTag"></div>
<div class="content">
  <pre #scrollMe [innerHTML]="highlightedCode" id="style-text"></pre>
</div>
